import { render, staticRenderFns } from "./RoServiceWorkItemPart.vue?vue&type=template&id=3dd80602&scoped=true"
import script from "./RoServiceWorkItemPart.vue?vue&type=script&lang=js"
export * from "./RoServiceWorkItemPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd80602",
  null
  
)

export default component.exports